import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { GenerateTokenService, Token } from 'integrationpingid-lib';

import { timeout } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { LocalStorageService } from 'src/app/services/shared/local-storage/local-storage.service';

import { environment } from 'src/environments/environment';
import { DialogsService} from "../../shared/dialogs.service";
import { NotificationService} from "../../shared/notification/notification.service";
import { ConfirmationDialogService} from "../../shared/confirmation-dialog/confirmation-dialog.service";
import { AuditService } from "../../shared/audit/audit.service";

@Injectable({
  providedIn: 'root'
})
export class BcraService {
  serviceName = "BcraService";

  objParams = {
    headers: this.getTokenToHeaders()
  };
  SOURCE: string = "AR_CREDIT/BCRA_GKL";

  private notificationService: NotificationService;
  private dialogo: DialogsService;
  private confirmationDialogService: ConfirmationDialogService;
  private auditService: AuditService;

  constructor(
    private http: HttpClient,
    public serviceToken: GenerateTokenService,
    private localStorageService: LocalStorageService,
    injector: Injector
  ) {
    this.notificationService = injector.get<NotificationService>(NotificationService);
    this.dialogo = injector.get<DialogsService>(DialogsService);
    this.confirmationDialogService = injector.get<ConfirmationDialogService>(ConfirmationDialogService);
    this.auditService = injector.get<AuditService>(AuditService);
  }

  getTokenToHeaders() {
    let headerDict: { Authorization: string; };
    if (this.localStorageService.getIsVip) {
      headerDict = {
        Authorization: "Bearer " + localStorage.getItem('access_token')
      };
    } else {
      let token: Token = {};
      if (this.serviceToken.statusTokenUser()) {
        token = this.serviceToken.getTokenUser();
      } else {
        // This is intentional
      }
      headerDict = {
        Authorization: token.token_type + " " + token.access_token,
      };
    }
    return headerDict;
  }

  getBcraListService(entityKeyEncoded: string, service: string, subdominiobcra: string) {
    console.log("subdominiobcra ---->", subdominiobcra);
    this.localStorageService.setObservationListMatchkey = entityKeyEncoded;
    const param = new HttpParams().set('matchkey', entityKeyEncoded);
    const objParams = {
      //headers: this.getTokenToHeaders(),
      params: param
    };



    // reemplazar SOURCE
    this.SOURCE = subdominiobcra;

    // cambio para ruta de Microservicios
    let rutaMicroservicio = (environment.MICROSERVICIO.toString().toLowerCase() === "true")
      ? "/" + this.localStorageService.configInit["F_URL_MS_IM_JOURNALING"]
      : "";

    const consumerAPI = environment.CONSUME_API_DATA.toString().toLowerCase() === "true";

    // ruta VIP - incluir la matriz en el llamado
    const typeData = service === "gkl" ? "_GKL" : "";
    const apiData = `assets/data/ar/preview/DATA_BCRA${typeData}.json`;
    if (this.localStorageService.getIsVip) {
      let sMatrizVip = {
        'matriz': this.localStorageService.getMatrizArray
      }
      let urlBaseApi = this.localStorageService.configInit["F_VIP_URL_BASE_API"];
      let apiVip = 'vip';

      const url = consumerAPI ?
        `${urlBaseApi}/${apiVip}/journaling-service/v4/sources/matriz/AR/${this.SOURCE}`
        : apiData;

      return this.http.post(
        url, sMatrizVip, objParams
      ).pipe(
        timeout(Number(environment.HTTP_REQUEST_TIMEOUT))
      )
    } else {
      const url = consumerAPI ?
        `${this.localStorageService.configInit["F_PINGID_URL_BASE_API"]}${rutaMicroservicio}/api/v4/sources/AR/${this.SOURCE}`
        : apiData;
      return this.http.get(
        url, objParams
      ).pipe(
        timeout(Number(environment.HTTP_REQUEST_TIMEOUT))
      )
    }

  }

  getDetails(bcraObject: any, mode?: any, service?: any) {
    console.log('%c ' + this.serviceName + " / " + 'getDetails(bcraObject, mode)', 'background: green; color: white');
    console.log("bcraObject : ", bcraObject);
    console.log("mode : ", mode);
    console.log("service : ", service);

    let source = bcraObject.tipo

    // cambio para ruta de Microservicios
    let rutaMicroservicio = (environment.MICROSERVICIO.toString().toLowerCase() === "true")
      ? this.localStorageService.configInit["F_URL_MS_IM_JOURNALING"] + "/"
      : "";

    let baseUrl = (this.localStorageService.getIsVip)
      ? this.localStorageService.configInit["F_VIP_URL_BASE_API"]
      : this.localStorageService.configInit["F_PINGID_URL_BASE_API"];
    let versionUrl = 'v3';
    let journalingUrl = this.localStorageService.getIsVip
      ? 'vip/journaling-service'
      : 'api';

    if (environment.MICROSERVICIO.toString().toLowerCase() === "true" && journalingUrl == 'api') {
      journalingUrl = rutaMicroservicio + 'api'
    }

    const sourceUrl = `${journalingUrl}/${versionUrl}/sources/details`;
    const country = "AR";
    const domain = "AR_CREDIT";

    // FIRST STAGE, EDIT MODE AND CREATE MODE
    if (mode && environment.CONSUME_API_DATA.toString().toLowerCase() === "true") {
      switch (mode) {
        case 'edit':
          let matchkeyDataEdit = String(bcraObject[0].matchKey).slice(0, -12);
          console.log("edit mode : ", matchkeyDataEdit);
          this.localStorageService.setMatchkeySelected = String(bcraObject[0].matchKey);
          const paramRefresh = new HttpParams().set('matchkey', matchkeyDataEdit);
          const objParamsRefresh = {
            headers: this.getTokenToHeaders(),
            params: paramRefresh
          };
          // Ruta VIP
          return this.http.get(
            `${baseUrl}/${sourceUrl}/${country}/${domain}/` + source, objParamsRefresh)
            .pipe(
              timeout(Number(environment.HTTP_REQUEST_TIMEOUT))
            )

        case 'create':
          let matchkeyDataCreate = String(bcraObject.entityKey + "." + bcraObject.adh_matriz_cod);
          console.log("create mode : ", matchkeyDataCreate);
          this.localStorageService.setMatchkeySelected = matchkeyDataCreate;
          const paramCreate = new HttpParams().set('matchkey', matchkeyDataCreate);

          const objParamsCreate = {
            headers: this.getTokenToHeaders(),
            params: paramCreate
          };
          // ruta VIP:
          return this.http.get(
            `${baseUrl}/${sourceUrl}/${country}/${domain}/` + source, objParamsCreate)
            .pipe(
              timeout(Number(environment.HTTP_REQUEST_TIMEOUT))
            )
        default:
          //NOTHING TO DO HERE
          break;
      }
    }

    // SECOND STAGE, DEFAULT MODE(call from bureau-list) AND MOCK MODE(call from bureau-details)
    let matchkeyData = String(bcraObject.matchKey).slice(0, -12);
    this.localStorageService.setMatchkeySelected = String(bcraObject.matchKey);
    const param = new HttpParams().set('matchkey', matchkeyData);
    const objParams = {
      headers: this.getTokenToHeaders(),
      params: param
    };
    const url = environment.CONSUME_API_DATA.toString().toLowerCase() === "true" ?
      `${baseUrl}/${sourceUrl}/${country}/${domain}/${source}`
      : `/assets/data/ar/detail/${source}.json`;
    // if (environment.CONSUME_API_DATA.toString().toLowerCase() === "true") {
    // ruta VIP

    return this.http.get(
      url, objParams
    ).pipe(
      timeout(Number(environment.HTTP_REQUEST_TIMEOUT))
    )

  }

  createListToDisplay(bcraListPayload) {
    let rows = [];
    for (const key in bcraListPayload.payload) {
      let currentType = bcraListPayload.payload[key];
      let bcraType = BCRA_TYPE_LIST.find(bt => bt.type === key);
      currentType.forEach(element => {
        let newRow = element;
        newRow.tipo = key;
        newRow.producto = bcraType.description
        rows.push(newRow)
      });
    }
    return rows;
  }

  getEstadosAcumulaList() {
    return ACUMULA_LIST;
  }

  getSituacionesList() {
    return SITUACIONES_BCRA;
  }

  getAsistenciasList() {
    return ASISTENCIAS_BCRA;
  }

  getLoanMonedaList() {
    return CURRENCY_LIST;
  }

  getListaEstadosBcra() {
    return ESTADOS_BCRA;
  }

  getSchemasDataViews(subDomain: string) {
    // cambio para ruta de Microservicios
    let rutaMicroservicio = (environment.MICROSERVICIO.toString().toLowerCase() === "true")
      ? this.localStorageService.configInit["F_URL_MS_IM_DIS"] + "/"
      : "";

    // ruta VIP
    let baseUrl = (this.localStorageService.getIsVip)
      ? this.localStorageService.configInit["F_VIP_URL_BASE_API"]
      : this.localStorageService.configInit["F_PINGID_URL_BASE_API"];
    const sourceUrl = this.localStorageService.getIsVip
      ? this.localStorageService.configInit["F_VIP_URL_DATAVIEW"]
      : rutaMicroservicio + this.localStorageService.configInit["F_URL_DATAWIEW"];
    const url = `${baseUrl}/${sourceUrl}/${subDomain}`;

    return this.http.get<any>(url).
    pipe(timeout(Number(environment.HTTP_REQUEST_TIMEOUT)))
  }

  /**
   * Muestra el modal de edición masiva para BCRA y procesa los cambios
   */
  async showBcraMassiveEdit(
    currentView: any,
    allPeriods: any[], // TODOS los períodos disponibles en preview2
    currentHistoryMatchKey: string,
    lastPreview1Selection: any,
    reloadPreviewCallback: (selection: any) => void,
    avroSchema: any[],
    header?: any
  ): Promise<void> {
    console.log("BcraService: Iniciando lógica de edición masiva para BCRA");

    if (currentView !== 'preview2') {
      this.notificationService.showInfo('Por favor, seleccione al menos un registro para la edición masiva.');
      return;
    }

    // Obtener campos editables dinámicos desde el schema
    const editableFields = this.getEditableFieldsFromSchema(avroSchema);

    // Usar el nuevo modal que incluye campos dinámicos
    const config = {
      height: 'auto',
      width: '800px',
      data: {
        subdomain: 'bcra',
        message: 'Edición Masiva de Períodos BCRA',
        content: 'data',
        list: this.getSituacionesList(),
        listestado: this.getListaEstadosBcra(),
        availableFields: editableFields
      }
    };

    const res = await this.dialogo.muestraMensajeBcra('message', config);

    if (res && res.status) {
      const confirmed = await this.confirmationDialogService.confirmActionWithComment(
        'Modificación Masiva',
        '¿Desea confirmar la edición masiva de los registros seleccionados?'
      );

      if (confirmed) {
        this.buildAndSendDisPayloadBcra(
          res,
          allPeriods, // Pasar TODOS los períodos para filtrar por rango
          currentHistoryMatchKey,
          avroSchema,
          header
        ).subscribe({
          next: (serviceRes) => {
            if (serviceRes) {
              this.notificationService.showSuccess('La edición masiva se solicitó correctamente.');
              if (lastPreview1Selection) {
                reloadPreviewCallback(lastPreview1Selection);
              }
            }
          },
          error: (err) => {
            this.notificationService.showError('Ocurrió un error en la edición masiva.');
            console.error(err);
          }
        });
      }
    }
  }

  /**
   * Construye y envía el payload de edición masiva al servicio DIS para BCRA
   * Replica la lógica de updateAllPeriod() de bcra-detail
   * Genera registros para TODOS los períodos en el rango, no solo los existentes
   */
  public buildAndSendDisPayloadBcra(
    res: any,
    allPeriods: any[], // TODOS los períodos (como arrayPeriodosHist en bcra-detail)
    currentHistoryMatchKey: string,
    avroSchema: any[],
    header?: any
  ): Observable<any> {
    if (allPeriods.length === 0) {
      if(this.notificationService) {
        this.notificationService.showInfo('No hay períodos disponibles para actualizar.');
      }
      return of(null);
    }

    // Extraer valores del modal
    const situacionTemp_cod = res.value;
    const estadoTemp_cod = res.estado;
    const periodoTemp_ini = res.periodoini;
    const periodoTemp_fin = res.periodofin;
    const comentarioTemp = res.comentarios;
    const detailedEdits = res.detailedEdits || {}; // Campos adicionales editados

    console.log('Valores del diálogo BCRA:');
    console.log('periodoTemp_ini:', periodoTemp_ini);
    console.log('periodoTemp_fin:', periodoTemp_fin);
    console.log('situacionTemp_cod:', situacionTemp_cod);
    console.log('estadoTemp_cod:', estadoTemp_cod);
    console.log('detailedEdits:', detailedEdits);
    console.log('Total períodos disponibles:', allPeriods.length);

    const dataArray = [];
    const fechafull = this.getCurrentDateTimeForBcra();
    const usuario = this.localStorageService.dataLogin?.getUser()?.toUpperCase() || 'SYSTEM';
    const fuente = this.localStorageService.getIsVip ? "VIP" : "DATA MAINTENANCE";

    // Tomar el primer período como base para datos comunes
    const baseItem = allPeriods[0];

    // Generar la lista completa de períodos en el rango, no solo los existentes
    const periodosEnRango = [];
    for (let periodo = periodoTemp_ini; periodo <= periodoTemp_fin; periodo++) {
      periodosEnRango.push(periodo);
    }

    console.log('Períodos a generar en el rango:', periodosEnRango);

    // Para cada período en el rango, crear/actualizar el registro
    periodosEnRango.forEach((periodoNum) => {
      // Buscar si existe un período con data para este número
      const existingPeriod = allPeriods.find(x => Number(this.itemPeriodo(x.periodo)) === periodoNum);

      let tempItem;
      if (existingPeriod) {
        // Si existe, usar los datos existentes como base
        tempItem = JSON.parse(JSON.stringify(existingPeriod));
        console.log(`Modificando período existente: ${periodoNum}`);
      } else {
        // Si no existe, crear nuevo registro basado en el baseItem
        tempItem = JSON.parse(JSON.stringify(baseItem));
        console.log(`Creando nuevo período: ${periodoNum}`);

        // Para períodos nuevos, establecer valores por defecto
        tempItem.deuda_total = 0;
        tempItem.monto_prestamos = tempItem.monto_prestamos || 0;
        tempItem.monto_participaciones = tempItem.monto_participaciones || 0;
        tempItem.monto_garant_otorgadas = tempItem.monto_garant_otorgadas || 0;
        tempItem.monto_otros_conceptos = tempItem.monto_otros_conceptos || 0;
      }

      // Setear el período específico
      tempItem.periodo = periodoNum;

      // Setear valores del modal
      tempItem.situacion_cod = situacionTemp_cod;
      tempItem.motivo = estadoTemp_cod;
      tempItem.comentarios = comentarioTemp;

      // Setear valores de operación
      tempItem.operacion_tipo = "MODIF";
      tempItem.fuente_tipo = "M";
      tempItem.operacion_fh = fechafull;
      tempItem.usuario = usuario;
      tempItem.fuente = fuente;
      tempItem.motivo_fh = fechafull;

      // Buscar descripción de situación
      const sitdescripcion = this.getSituacionesList().find(
        (s) => String(s.code) === String(situacionTemp_cod)
      )?.description || '';
      tempItem.situacion_desc = sitdescripcion;

      // Buscar descripción de moneda
      const mondescripcion = this.getLoanMonedaList().find(
        (m) => String(m.code) === String(tempItem.moneda)
      )?.description || '';
      tempItem.moneda_desc = mondescripcion;

      // Aplicar campos editados detallados (campos dinámicos del modal)
      if (detailedEdits && Object.keys(detailedEdits).length > 0) {
        for (const [fieldName, fieldValue] of Object.entries(detailedEdits)) {
          tempItem[fieldName] = fieldValue;
        }
      }

      // Formatear según schema
      const formattedItem = this.disObjectCreator(tempItem, avroSchema);
      dataArray.push(JSON.stringify(formattedItem));
    });

    console.log('Total items a enviar:', dataArray.length);

    if (dataArray.length === 0) {
      this.notificationService.showInfo('No hay períodos en el rango seleccionado para actualizar.');
      return of(null);
    }

    const auditData = this.auditService.buildAuditForMassiveBcra(baseItem, res, currentHistoryMatchKey);
    const payload: any = {
      data: dataArray,
      audit: auditData,
      purposingProfiles: ["PURP_AR_CREDIT_DEBTORS_FINANCIAL_SYSTEM_KL"]
    };

    // Determinar el tipo de BCRA desde el primer item
    const bcraType = baseItem?.tipo || 'BCRA_FINANCIAL_STATUS';

    return this.postDisPayload("AR_CREDIT/" + bcraType, payload);
  }

  /**
   * Normaliza el período a formato numérico comparable
   * Replica la función itemPeriodo de bcra-detail
   */
  private itemPeriodo(periodo: any): number {
    if (typeof periodo === 'number') {
      return periodo;
    }
    if (typeof periodo === 'string') {
      return parseInt(periodo.replace(/\D/g, ''));
    }
    return 0;
  }

  /**
   * Obtiene la fecha actual en formato YYYYMMDD para BCRA
   */
  private getCurrentDateTimeForBcra(): number {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');

    return parseInt(`${year}${month}${day}`);
  }


  /**
   * Crea el objeto DIS formateado según el schema AVRO
   * Basado en el método disObjectCreator de bcra-detail.component
   */
  public disObjectCreator(tempItem: any, avroSchema: any[]): any {
    const actualObject = {};
    const tempDataview = avroSchema;

    if (!tempDataview) {
      console.error(`No se encontró la definición de DATAVIEWS para BCRA`);
      return tempItem;
    }

    // Recorrer cada campo del dataview
    tempDataview.forEach((itemStructure: any) => {
      // Caso especial: keying
      if (itemStructure.name === 'keying') {
        actualObject[itemStructure.name] = this.setKeying(tempItem);
      } else {
        // Otros atributos
        if (tempItem[itemStructure.name] != null) {
          if (Array.isArray(itemStructure.type)) {
            // Tipo opcional (union type en AVRO)
            this.getDisValue(itemStructure, tempItem, actualObject);
          } else {
            // Tipo simple
            this.parseValue(itemStructure, actualObject, tempItem);
          }
        } else {
          // Valor null
          this.parseValue(itemStructure, actualObject, tempItem);
        }
      }
    });

    return actualObject;
  }

  /**
   * Formatea el objeto keying para DIS
   */
  private setKeying(tempItem: any): any[] {
    if (!tempItem.keying || !tempItem.keying[0]) {
      console.warn('No se encontró keying en el item');
      return [];
    }

    const entityType = tempItem.keying[0].request.session.entityType;

    // Ajustar profileId para comerciales si es necesario
    if (entityType === "COMMERCIAL") {
      tempItem.keying[0].request.session.profileId =
        this.localStorageService.configInit?.["F_PROFILE_COMMERCIAL_2"] ||
        tempItem.keying[0].request.session.profileId;
    }

    let tempEntity = null;

    switch (entityType) {
      case "COMMERCIAL":
        tempEntity = {
          "commercial": {
            "com.equifax.fabric.keying.common.v1.Commercial": tempItem.keying[0].request.entity.commercial,
          },
          "consumer": null,
        };
        break;
      case "CONSUMER":
      default:
        tempEntity = {
          "consumer": {
            "com.equifax.fabric.keying.common.v1.Consumer": tempItem.keying[0].request.entity.consumer,
          },
          "commercial": null,
        };
        break;
    }

    const tempKeying = [
      {
        "request": {
          "session": {
            "com.equifax.fabric.keying.common.v1.Session": tempItem.keying[0].request.session,
          },
          "entity": tempEntity
        },
        "response": null
      }
    ];

    return tempKeying;
  }

  /**
   * Parsea valores simples
   */
  private parseValue(itemStructure: any, actualObject: any, tempItem: any): void {
    switch (itemStructure.type) {
      case "double":
        actualObject[itemStructure.name] = parseFloat(tempItem[itemStructure.name]);
        break;
      case "int":
        actualObject[itemStructure.name] = parseInt(tempItem[itemStructure.name]);
        break;
      default:
        actualObject[itemStructure.name] = tempItem[itemStructure.name];
        break;
    }
  }

  /**
   * Obtiene el valor DIS con tipo envuelto (para union types de AVRO)
   */
  private getDisValue(itemStructure: any, tempItem: any, actualObject: any): void {
    const optionalItemValue = {};
    const tempType = this.getItemType(itemStructure.type);

    switch (tempType) {
      case "double":
        optionalItemValue[tempType] = parseFloat(tempItem[itemStructure.name]);
        break;
      case "int":
        optionalItemValue[tempType] = parseInt(tempItem[itemStructure.name]);
        break;
      case "boolean":
        optionalItemValue[tempType] = Boolean(tempItem[itemStructure.name]);
        break;
      default:
        optionalItemValue[tempType] = tempItem[itemStructure.name];
        break;
    }

    actualObject[itemStructure.name] = optionalItemValue;
  }

  /**
   * Obtiene el tipo de dato del array de tipos AVRO (excluye "null")
   */
  private getItemType(typeArray: any[]): string {
    if (!Array.isArray(typeArray)) {
      return typeArray;
    }
    // Filtrar "null" y retornar el tipo real
    const nonNullType = typeArray.find(t => t !== "null");
    return nonNullType || "string";
  }

  /**
   * Envía el payload al servicio DIS
   */
  public postDisPayload(source: string, payload: any): Observable<any> {

    console.log("PAYLOAD BCRA POST EDICION MASIVA: ", payload);

    const urlBaseApi = (this.localStorageService.getIsVip)
      ? environment.VIP_URL_BASE_API
      : this.localStorageService.configInit["F_PINGID_URL_BASE_API"];
    const rutaMicroservicio = (environment.MICROSERVICIO.toString().toLowerCase() === "true")
      ? "/" + (this.localStorageService.getIsVip
      ? 'vip/dis-service'
      : this.localStorageService.configInit["F_URL_MS_IM_DIS"])
      : "";
    const API_VERSION = this.localStorageService.getIsVip
      ? 'v2'
      : 'api/v2';

    if (environment.CONSUME_API_DATA.toString().toLowerCase() === "true") {
      return this.http.post<any>(
        `${urlBaseApi}${rutaMicroservicio}/${API_VERSION}/DIS/AR/${source}`,
        payload, {
          headers: this.getTokenToHeaders()
        }).pipe(timeout(Number(environment.HTTP_REQUEST_TIMEOUT)));
    } else {
      return of({ "type": "mockResponse", "data": payload });
    }
  }

  /**
   * Retorna las definiciones de campos editables para BCRA
   * TODO: Obtener esto desde la configuración o servicio
   */
  public getBcraFieldDefinitions(): any[] {
    console.log("BcraService: Proveyendo definiciones de campos...");
    return [
      // Campos editables comunes en BCRA
      { name: 'situacion', label: 'Situación', section: 'Detalles', editable: true, visible: true, inputType: 'select', options: SITUACIONES_BCRA },
      { name: 'acumula', label: 'Acumula', section: 'Detalles', editable: true, visible: true, inputType: 'select', options: ACUMULA_LIST },
      { name: 'estado', label: 'Estado', section: 'Detalles', editable: true, visible: true, inputType: 'select', options: ESTADOS_BCRA },
      { name: 'tipo_asistencia', label: 'Tipo de Asistencia', section: 'Detalles', editable: true, visible: true, inputType: 'select', options: ASISTENCIAS_BCRA },
    ];
  }

  /**
   * Extrae campos editables desde el schema AVRO
   * Filtra campos que sean editables y les asigna el tipo de input apropiado
   */
  private getEditableFieldsFromSchema(avroSchema: any[]): any[] {
    if (!avroSchema || avroSchema.length === 0) {
      console.warn("No hay schema AVRO disponible para extraer campos editables");
      return [];
    }

    const editableFields = [];

    // Campos especiales que queremos permitir editar
    const editableFieldsConfig = {
      'acumula': { label: 'Acumula', inputType: 'select', options: ACUMULA_LIST },
      'moneda': { label: 'Moneda', inputType: 'select', options: this.getLoanMonedaList() },
      'tipo_asistencia': { label: 'Tipo de Asistencia', inputType: 'select', options: ASISTENCIAS_BCRA },
      'deuda_total': { label: 'Deuda Total', inputType: 'number' },
      'monto_prestamos': { label: 'Monto Préstamos', inputType: 'number' },
      'monto_participaciones': { label: 'Monto Participaciones', inputType: 'number' },
      'monto_garant_otorgadas': { label: 'Monto Garantías Otorgadas', inputType: 'number' },
      'monto_otros_conceptos': { label: 'Monto Otros Conceptos', inputType: 'number' }
    };

    avroSchema.forEach((field: any) => {
      const fieldName = field.name;

      // Excluir campos del sistema que no se deben editar
      const excludedFields = ['keying', 'operacion_tipo', 'fuente_tipo', 'operacion_fh',
        'usuario', 'fuente', 'periodo', 'matchKey', 'entityKey'];

      if (excludedFields.includes(fieldName)) {
        return;
      }

      // Si el campo está en nuestra configuración de editables
      if (editableFieldsConfig[fieldName]) {
        const config = editableFieldsConfig[fieldName];
        editableFields.push({
          name: fieldName,
          label: config.label,
          inputType: config.inputType,
          options: config.options || []
        });
      }
    });

    console.log("Campos editables extraídos del schema:", editableFields);
    return editableFields;
  }

}


const BCRA_TYPE_LIST = [
  { type: 'BCRA_FINANCIAL_STATUS', code: "FS", description: "FINANCIAL STATUS" },
  { type: 'BCRA_FINANCIAL_STATUS_24M', code: "FS24M", description: "FINANCIAL STATUS 24M" },
];

const ACUMULA_LIST = [
  { code: "", description: "--" },
  { code: "B", description: "BAJA" },
  { code: "S", description: "SI" },
  { code: "N", description: "NO" },
];

const SITUACIONES_BCRA = [
  { code: "0", description: "-" },
  { code: "-", description: "-" },
  { code: "1", description: "En situacion normal/Situacion normal" },
  { code: "2", description: "En tratamiento Especial" },
  { code: "21", description: "En observacion/ Riesgo Bajo" },
  { code: "22", description: "En negociacion o con acuerdos de refinanciacion" },
  { code: "23", description: "En tratamiento Especial" },
  { code: "3", description: "Con problemas/Riesgo Medio" },
  { code: "4", description: "Con alto riesgo de insolvencia/ Riesgo Alto" },
  { code: "5", description: "Irrecuperable" },
  { code: "6", description: "Irrecuperable por disposicion tecnica" },
  { code: "11", description: "Con asistencias cubiertas en su totalidad con garantias preferidas 'A'" },
  { code: "99", description: "Deudor no clasificado" },
]

const ASISTENCIAS_BCRA = [
  { code: "-", description: "VACIO" },
  { code: "01", description: "Adelantos" },
  { code: "02", description: "Descuento de titulos de credito" },
  { code: "04", description: "Documentos a sola firma, Descontados y Comprados" },
  { code: "05", description: "Hipotecarios sobre la vivienda" },
  { code: "06", description: "Con garantias hipotecarias" },
  { code: "07", description: "Prendarios sobre automotores" },
  { code: "08", description: "Con otras garantias prendarias" },
  { code: "09", description: "Personales" },
  { code: "10", description: "Tarjetas de credito" },
  { code: "11", description: "Prestamos interfinancieros no provisionales" },
  { code: "12", description: "Prestamos a entidades financieras publicas con participacion estatal mayoritaria cubiertos con garantia del gobierno de la respectiva jurisdiccion." },
  { code: "13", description: "Otros prestamos" },
  { code: "14", description: "Otros creditos por intermediacion financiera" },
  { code: "15", description: "Creditos por arrendamientos financieros" },
  { code: "16", description: "Creditos diversos" },
  { code: "17", description: "Prestamos de monto reducido" },
  { code: "18", description: "Prestamos adicionales" },
  { code: "19", description: "Prestamos a instituciones de Microcredito" },
  { code: "20", description: "Prestamos a Microemprendedores" },
  { code: "21", description: "Prestamos para prefinanciacion y financiacion de exportaciones" },
]

const ESTADOS_BCRA = [
  { code: "-", description: "VACIO" },
  { code: "CAN", description: "CANCELÓ SU DEUDA" },
  { code: "DHD", description: "DEMANDA HD ART. 38" },
  { code: "ELB", description: "ELIMINACIÓN-BAJA" },
  { code: "ELI", description: "ELIMINACIÓN" },
  { code: "HD", description: "BLOQUEO HD ART. 16" },
  { code: "MOD", description: "CAMBIO DE SITUACIÓN" },
  { code: "NOC", description: "MODIFICACIÓN" },
  { code: "REF", description: "REFINANCIÓ SU DEUDA" },
  { code: "REG", description: "REGULARIZÓ SU DEUDA" },
  { code: "TRA", description: "TRANSFIRIÓ SU DEUDA" }
]

const CURRENCY_LIST = [
  { code: "-", description: "VACIO" },
  { code: "ADP", description: "PESETA ANDORRANA" },
  { code: "AED", description: "UAE DIRHAM" },
  { code: "AFA", description: "AFGHANI" },
  { code: "ALL", description: "LEK ALBANIA" },
  { code: "ANG", description: "NETHERLANDS ANTILLEAN" },
  { code: "AON", description: "NEW KWANZA" },
  { code: "ARS", description: "PESOS ARG." },
  { code: "ATS", description: "CHELIN" },
  { code: "AUD", description: "DOLAR AUSTRALIANO" },
  { code: "AWG", description: "GUILDER ARUBA" },
  { code: "BBD", description: "DOLAR BARBADOS" },
  { code: "BDT", description: "TAKA" },
  { code: "BEF", description: "FRANCO BELGA" },
  { code: "BGL", description: "LEV" },
  { code: "BHD", description: "BAHRAINI DINAR" },
  { code: "BIF", description: "FRANCO BURUNDI" },
  { code: "BMD", description: "DOLAR BERMUDAS" },
  { code: "BND", description: "DOLAR BRUNEI" },
  { code: "BOB", description: "BOLIVIANO" },
  { code: "BRR", description: "CRUZEIRO REAL" },
  { code: "BSD", description: "DOLAR BAHAMAS" },
  { code: "BTN", description: "NGULTRUM" },
  { code: "BWP", description: "PULA" },
  { code: "BZD", description: "DOLAR BELIZE" },
  { code: "CAD", description: "DOLAR CANADIENSE" },
  { code: "CHF", description: "FRANCO SUIZO" },
  { code: "CLP", description: "PESO CHILENO" },
  { code: "CNY", description: "YUAN RENMINBI" },
  { code: "COP", description: "PESO COLOMBIANO" },
  { code: "CRC", description: "COLON COSTA RICA" },
  { code: "CUP", description: "PESO CUBANO" },
  { code: "CVE", description: "ESCUDO CAPE VERDE" },
  { code: "CYP", description: "LIBRA CYPRUS" },
  { code: "CZK", description: "KORUNA CHECOSLOVACA" },
  { code: "DEM", description: "MARCO ALEMAN" },
  { code: "DJF", description: "FRANCO DJIBOUTI" },
  { code: "DKK", description: "KRONE DANES" },
  { code: "DOP", description: "PESO DOMINICANO" },
  { code: "DZD", description: "ALGERIAN DINAR" },
  { code: "ECS", description: "SUCRE" },
  { code: "EEK", description: "KROON" },
  { code: "EGP", description: "LIBRA EGIPCIA" },
  { code: "ESP", description: "PESETA ESPANOLA" },
  { code: "ETB", description: "BIRR ETIOPIA" },
  { code: "FIM", description: "MARKKA" },
  { code: "FJD", description: "DOLAR FIJI" },
  { code: "FKP", description: "LIBRAS MALVINAS" },
  { code: "FRF", description: "FRANCOS FRANCESES" },
  { code: "GBP", description: "LIBRAS ESTERLINAS" },
  { code: "GHC", description: "CEDI" },
  { code: "GIP", description: "LIBRA GIBRALTAR" },
  { code: "GMD", description: "DALASI" },
  { code: "GNF", description: "FRANCO GUINEA" },
  { code: "GRD", description: "DRACHMA" },
  { code: "GTQ", description: "QUETZAL" },
  { code: "GWP", description: "PESO GUINEA BIASSAU" },
  { code: "GYD", description: "DOLAR GUYANA" },
  { code: "HKD", description: "DOLAR HONG KONG" },
  { code: "HNL", description: "LEMPIRA" },
  { code: "HRD", description: "DINAR CROACIA" },
  { code: "HTG", description: "GOURDE" },
  { code: "HUF", description: "FORINT" },
  { code: "IDR", description: "RUPIA" },
  { code: "IEP", description: "LIBRA IRLANDESA" },
  { code: "ILS", description: "SHEKEL" },
  { code: "INR", description: "RUPIA INDIA" },
  { code: "IQD", description: "DINAR IRAQUI" },
  { code: "IRR", description: "RIAL IRANI" },
  { code: "ISK", description: "KRONA ISLANDIA" },
  { code: "ITL", description: "LIRA ITALIANA" },
  { code: "JMD", description: "DOLAR JAMAICANO" },
  { code: "JOD", description: "DINAR JORDANO" },
  { code: "JPY", description: "YEN" },
  { code: "KES", description: "CHELIN KENYA" },
  { code: "KGS", description: "SOM" },
  { code: "KHR", description: "RIEL" },
  { code: "KMF", description: "FRANCO COMORO" },
  { code: "KPW", description: "WON COREA DEL NORTE" },
  { code: "KRW", description: "WON" },
  { code: "KWD", description: "DINAR KUWAITI" },
  { code: "KYD", description: "DOLAR ISLAS  CAIMAN" },
  { code: "LAK", description: "KIP" },
  { code: "LBP", description: "LIBRA LIBANESA" },
  { code: "LKR", description: "RUPIA SRI LANKA" },
  { code: "LRD", description: "DOLAR LIBERIANO" },
  { code: "LSL", description: "LOTI" },
  { code: "LTL", description: "LITAS LITUANAS" },
  { code: "LUF", description: "FRANCO LUXEMBURGUES" },
  { code: "LVL", description: "LATS LATVIA" },
  { code: "LVR", description: "RUBLE LATVIA" },
  { code: "LYD", description: "DINAR LIBIA" },
  { code: "MAD", description: "DIRHAM MARROQUI" },
  { code: "MDL", description: "LEU MOLDOVA" },
  { code: "MGF", description: "FRANCO MADAGASCAR" },
  { code: "MKD", description: "DENAR" },
  { code: "MMK", description: "KYAT" },
  { code: "MNT", description: "TUGRIK" },
  { code: "MOP", description: "PATACA" },
  { code: "MRO", description: "OUGUIYA" },
  { code: "MTL", description: "LIRA MALTA" },
  { code: "MUR", description: "RUPIA MAURITIUS" },
  { code: "MVR", description: "RUFIYAA" },
  { code: "MWK", description: "KWACHA" },
  { code: "MXN", description: "NUEVO PESO MEXICANO" },
  { code: "MYR", description: "RINGGIT MALAYSIA" },
  { code: "MZM", description: "METICAL" },
  { code: "NAD", description: "DOLAR NAMIBIA" },
  { code: "NGN", description: "NAIRA" },
  { code: "NIO", description: "CORDOBA ORO" },
  { code: "NLG", description: "FLORIN PAISES BAJOS" },
  { code: "NOK", description: "NORWEGIAN KRONE" },
  { code: "NPR", description: "RUPIA NEPAL" },
  { code: "NZD", description: "DOLAR NUEVA ZELANDIA" },
  { code: "OMR", description: "RIAL OMANI" },
  { code: "PAB", description: "BALBOA" },
  { code: "PEN", description: "NUEVO SOL" },
  { code: "PGK", description: "KINA" },
  { code: "PHP", description: "PESO FILIPINO" },
  { code: "PKR", description: "RUPIA PAKISTANI" },
  { code: "PLZ", description: "ZLOTY" },
  { code: "PTE", description: "ESCUDO PORTUGUES" },
  { code: "PYG", description: "GUARANI" },
  { code: "QAR", description: "QATARI RIAL" },
  { code: "ROL", description: "LEU" },
  { code: "RUR", description: "RUBLO RUSO" },
  { code: "RWF", description: "FRANCO RWANDA" },
  { code: "SAR", description: "RIYAL SAUDI" },
  { code: "SBD", description: "DOLAR ISLAS SALOMON" },
  { code: "SCR", description: "RUPIA SYCHELLES" },
  { code: "SDD", description: "DINAR SUDAN" },
  { code: "SEK", description: "CORONA SUECA" },
  { code: "SGD", description: "DOLAR SINGAPUR" },
  { code: "SHP", description: "LIBRA SANTA ELENA" },
  { code: "SIT", description: "TOLAR" },
  { code: "SKK", description: "KORUNA ESLOVACA" },
  { code: "SLL", description: "LEONE" },
  { code: "SOS", description: "CHELIN SOMALI" },
  { code: "SRG", description: "FLORIN SURINAN" },
  { code: "STD", description: "DOBRA" },
  { code: "SVC", description: "EL SALVADOR COLON" },
  { code: "SYP", description: "LIBRA SIRIA" },
  { code: "SZL", description: "LILANGENI" },
  { code: "THB", description: "BAHT" },
  { code: "TMM", description: "MANAT" },
  { code: "TND", description: "DINAR TUNISIANO" },
  { code: "TPE", description: "ESCUDO TIMOR" },
  { code: "TRL", description: "LIRA TURCA" },
  { code: "TTD", description: "DOLAR TRINIDAD Y TOBAGO" },
  { code: "TWD", description: "DOLAR NUEVO TAIWAN" },
  { code: "TZS", description: "CHELIN TANZANIA" },
  { code: "UAK", description: "KARBOVANET" },
  { code: "UGX", description: "CHELIN UGANDA" },
  { code: "USD", description: "DOLARES" },
  { code: "USN", description: "US DOLAR NEXT DAY FUNDS" },
  { code: "UYU", description: "PESO URUGUAYO" },
  { code: "VEB", description: "BOLIVAR" },
  { code: "VND", description: "DONG" },
  { code: "VUV", description: "VATU" },
  { code: "WST", description: "TALA" },
  { code: "XAF", description: "CFA FRANCO BEAC" },
  { code: "XAG", description: "PLATA" },
  { code: "XAU", description: "ORO" },
  { code: "XBA", description: "EUROPEAN COMPOSITE UNIT(EURCO)" },
  { code: "XBB", description: "EUROPEAN MONETARY UNIT (EMU-6)" },
  { code: "XBC", description: "EUROPEAN UNIT OF ACCOUNT9/EUA9" },
  { code: "XBD", description: "EUROPEAN UNIT OF ACCOUNT17" },
  { code: "XCD", description: "DOLAR CARIBE ESTE" },
  { code: "XDR", description: "SDR IMF/INT MONETARY FUND" },
  { code: "XEU", description: "EUROPEAN CURRENCY UNIT (ECU)" },
  { code: "XFO", description: "FRANCO ORO (CONVENIO ESPECIAL)" },
  { code: "XFU", description: "UIC FRANCO (CONVENIO ESPECIAL)" },
  { code: "XOF", description: "CFA FRANCO BCEAO" },
  { code: "XPD", description: "PALLADIUM" },
  { code: "XPF", description: "CFP FRANCO" },
  { code: "XPT", description: "PLATINO" },
  { code: "XXX", description: "TRANSACTIONS WITHOUT CURRENCY" },
  { code: "YER", description: "RIAL YEMEN" },
  { code: "YUN", description: "DINAR YUGOSLAVIA" },
  { code: "ZAL", description: "FINANCIAL RAND" },
  { code: "ZAR", description: "RAND" },
  { code: "ZMK", description: "KWACHA" },
  { code: "ZRN", description: "NUEVO ZAIRE" },
  { code: "ZRZ", description: "ZAIRE" },
  { code: "ZWD", description: "DOLAR ZIMBABWE" },
  { code: "EUR", description: "EURO" }
];
